// extracted by mini-css-extract-plugin
export default {"control":"DeductionSortFilter_control__8JH-Z","text":"DeductionSortFilter_text__C8aOE"};